import { useSelector } from 'react-redux';
import { ADMIN_CONTACT_CITY, ADMIN_CONTACT_CREATABLE_TYPES } from '../../../constants/admin.contacts.constants';
import { currentUserSelector } from '../../../selectors/auth.selectors';
import contactsPermissionsService from '../../../services/permissions/contacts.permissions.service';
import { INPUT_STATES } from '../../forms/forms.utils';
import SelectField from '../../forms/SelectField';
import TextField from '../../forms/TextField';

const AdminContactSharedFields = ({
  isEdit,
  data,
  inputName,
  isSubmitting,
  validation,
  onInput,
  onEnter,
  parentElement,
  canUpdate
}) => {
  const currentUser = useSelector(currentUserSelector);
  const canAddPartnerContacts = contactsPermissionsService.canAddPartnerContacts(currentUser);

  const onTypeChange = (value) => {
    onInput(value, 'type');
  };

  return (
    <>
      <TextField
        className="u-margin-top-xs"
        label="Voornaam"
        name={inputName}
        value={data?.firstName}
        required
        state={INPUT_STATES.DEFAULT}
        onKeyDown={onEnter}
        onChange={(value) => onInput(value, 'firstName')}
        disabled={isSubmitting}
        hasError={!!validation?.firstName}
        validationError={validation?.firstName ?? ''}
        readOnly={!canUpdate}
      />
      <TextField
        label="Achternaam"
        name={inputName}
        value={data?.lastName}
        state={INPUT_STATES.DEFAULT}
        required
        onKeyDown={onEnter}
        onChange={(value) => onInput(value, 'lastName')}
        disabled={isSubmitting}
        hasError={!!validation?.lastName}
        validationError={validation?.lastName ?? ''}
        readOnly={!canUpdate}
      />
      <TextField
        label="E-mail"
        name={inputName}
        value={data?.email}
        state={INPUT_STATES.DEFAULT}
        onKeyDown={onEnter}
        required={!(data?.type === ADMIN_CONTACT_CITY)}
        onChange={(value) => onInput(value, 'email')}
        disabled={isSubmitting}
        hasError={!!validation?.email}
        validationError={validation?.email ?? ''}
        readOnly={!canUpdate}
      />
      <TextField
        label="Telefoon"
        name={inputName}
        value={data?.phone}
        state={INPUT_STATES.DEFAULT}
        onKeyDown={onEnter}
        onChange={(value) => onInput(value, 'phone')}
        disabled={isSubmitting}
        hasError={!!validation?.phone}
        validationError={validation?.phone ?? ''}
        readOnly={!canUpdate}
      />
      <SelectField
        id="add-contact-modal-type-select"
        label="Type"
        name={'type'}
        required
        onChange={onTypeChange}
        disableSearch={true}
        options={ADMIN_CONTACT_CREATABLE_TYPES}
        value={data?.type}
        className="u-margin-top"
        disabled={!canAddPartnerContacts || isSubmitting}
        parentElement={parentElement}
        readOnly={isEdit || !canUpdate}
        hasError={!!validation?.type}
        validationError={validation?.type ?? ''}
      />
    </>
  );
};

export default AdminContactSharedFields;
